/** @format */

import {MouseEvent, ReactNode, useState} from 'react';

import {Box, Popover} from '@mui/material';

import {HelpOutlined} from '@mui/icons-material';

import {Root, HelpButton, PlanText, IconWrap} from './styles';
import {HelpContent} from '../HelpContent';

interface Props {
  IconComponent: ReactNode;
  upperText: string;
  lowerText: string;
  helpHeaderText: string;
  helpContent: ReactNode;
}

const PlanElement = ({IconComponent, upperText, lowerText, helpHeaderText, helpContent}: Props) => {
  const [hover, setHover] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  const handleCloseHelp = () => {
    setAnchorEl(null);
    setHover(false);
  };

  const handleClickHelp = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Root onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} active={open}>
      <IconWrap active={open}>{IconComponent}</IconWrap>

      <Box>
        <PlanText active={open}>{upperText}</PlanText>
        <PlanText active={open}>{lowerText}</PlanText>
      </Box>

      <HelpButton disableRipple onClick={handleClickHelp} boxHover={hover} active={open}>
        <HelpOutlined sx={{fontSize: '16px'}} />
      </HelpButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseHelp}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          marginLeft: '4px',
        }}
        slotProps={{
          paper: {
            sx: {
              background: 'none',
              borderRadius: '8px',
            },
          },
        }}
      >
        <HelpContent onClose={handleCloseHelp} headerText={helpHeaderText} content={helpContent} />
      </Popover>
    </Root>
  );
};

export {PlanElement};
